module.exports = __webpack_public_path__ + "img/Welding-Training-02.15870feb.jpg";